import DISPLAY from './display';
import FIELD from './field';
import STYLE from './style.module.css';

const address = { DISPLAY, FIELD, STYLE };

export default address;
